__turbopack_context__.v({
  "icon": "QuickView-module-scss-module__LsyT2a__icon",
});
